var SubjectManager = (function () {
    function SubjectManager(logger) {
        this.job = new Map();
        this.logger = logger;
    }
    SubjectManager.prototype.hasJobSubject = function (idJob) {
        return this.job.has(String(idJob));
    };
    SubjectManager.prototype.registerJobSubject = function (idJob, subject) {
        var key = String(idJob);
        this.job.set(key, subject);
    };
    SubjectManager.prototype.findJobSubject = function (identifier) {
        var id = String(identifier);
        if (!this.job.has(id)) {
            throw new Error("could not find job subject for id=" + identifier);
        }
        return this.job.get(id);
    };
    SubjectManager.prototype.removeJobSubject = function (idJob) {
        var id = String(idJob);
        if (!this.job.has(id)) {
            this.logger.warn("No subject found for idJob " + id);
            return;
        }
        this.job.delete(id);
    };
    SubjectManager.prototype.getJobSubject = function (idJob) {
        var id = String(idJob);
        if (!this.job.has(id)) {
            this.logger.warn("No subject found for idJob " + id);
            return;
        }
        return this.job.get(id);
    };
    Object.defineProperty(SubjectManager.prototype, "jobs", {
        get: function () {
            return this.job;
        },
        enumerable: false,
        configurable: true
    });
    return SubjectManager;
}());
export { SubjectManager };
//# sourceMappingURL=SubjectManager.js.map